document.addEventListener("DOMContentLoaded", function () {
  const pincodeData = {
    "40": ["560001","560002"],
    "120": ["560003","560004","560005","560006","560007","560008","560009","560010","560011","560012","560013","560014","560015","560016","560017","560018","560019","560020","560021","560022","560023","560024","560025","560026","560027","560028","560029","560030","560032","560033","560034","560035","560036","560037","560038","560039","560040","560041","560042","560043","560045","560046","560047","560048","560049","560050","560051","560052","560053","560054","560055","560056","560058","560059","560061","560062","560063","560064","560065","560066","560067","560068","560069","560070","560071","560072","560073","560074","560075","560076","560077","560078","560079","560080","560083","560084","560085","560086","560087","560091","560092","560093","560094","560095","560096","560097","560098","560099","560100","560102","560103","560104","560105","562106","562107","562125","562130","562149","562157"],
    "Next Day": ["565566"],
    "2-6 Days": ["565567"]
  };

  let currentPincode = "560001";
  let currentDeliveryTime = "PIN";

  const deliveryWidget = document.getElementById("delivery-widget");
  const pincodeText = document.getElementById("pincode-text");
  const deliveryTimeBadge = document.getElementById("delivery-time");
  const pincodePopup = document.getElementById("pincode-popup");
  const pincodeInput = document.getElementById("pincode-input");
  const applyPincodeBtn = document.getElementById("apply-pincode-btn");
  const changePincodeBtn = document.getElementById("change-pincode-btn");
  const pincodeError = document.getElementById("pincode-error");
  const closePopupBtn = document.getElementById("close-popup-btn");

  function updateHeader(pincode, deliveryTime) {
    pincodeText.textContent = pincode;

    let number = "";
    let label = "";

    switch (deliveryTime) {
      case "40":
        number = "40";
        label = "Mins";
        break;
      case "120":
        number = "120";
        label = "Mins";
        break;
      case "Next Day":
        number = "Next";
        label = "Day";
        break;
      case "2-6 Days":
        number = "2-6";
        label = "Days";
        break;
      default:
        number = deliveryTime;
        label = "";
    }

    deliveryTimeBadge.innerHTML = `
      <div class="delivery-time-inner">
        <span class="delivery-number">${number}</span><br/>
        <span class="delivery-unit">${label}</span>
      </div>
    `;
  }

  function updateDeliveryTime(pincode) {
    if (pincodeData["40"].includes(pincode)) {
      currentDeliveryTime = "40";
      updateHeader(pincode, "40");
      pincodePopup.style.display = "none";
    } else if (pincodeData["120"].includes(pincode)) {
      currentDeliveryTime = "120";
      updateHeader(pincode, "120");
      pincodePopup.style.display = "none";
    } else if (pincodeData["Next Day"].includes(pincode)) {
      currentDeliveryTime = "Next Day";
      updateHeader(pincode, "Next Day");
      pincodePopup.style.display = "none";
    } else if (pincodeData["2-6 Days"].includes(pincode)) {
      currentDeliveryTime = "2-6 Days";
      updateHeader(pincode, "2-6 Days");
      pincodePopup.style.display = "none";
    } else {
      pincodeError.style.display = "block";
    }
  }

  deliveryWidget.addEventListener("click", function () {
    pincodeInput.value = '';
    pincodeError.style.display = "none";
    pincodePopup.style.display = "block";
    changePincodeBtn.style.display = "none";
  });

  closePopupBtn.addEventListener("click", function () {
    pincodePopup.style.display = "none";
  });

  applyPincodeBtn.addEventListener("click", function () {
    const enteredPincode = pincodeInput.value.trim();
    if (enteredPincode) {
      pincodeError.style.display = "none";
      updateDeliveryTime(enteredPincode);
      if (
        pincodeData["40"].includes(enteredPincode) ||
        pincodeData["120"].includes(enteredPincode) ||
        pincodeData["Next Day"].includes(enteredPincode) ||
        pincodeData["2-6 Days"].includes(enteredPincode)
      ) {
        changePincodeBtn.style.display = "block";
      }
    }
  });

  changePincodeBtn.addEventListener("click", function () {
    pincodePopup.style.display = "block";
    pincodeInput.value = '';
    pincodeError.style.display = "none";
    changePincodeBtn.style.display = "none";
  });

  // Initial render
  updateHeader(currentPincode, currentDeliveryTime);
});